import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import getComponent from './getComponent';

const regexToDetectTextInsideTags = /{(.*?)}/g; //i.e: ['{whateverComesFromBE}', '{whatever2}']

/**
 * function to get the data from the wildcards component
 * @param  {object} sitecoreContext dictionary with the information of all wildcards
 * @return {object} Dictionary with the data of the wildcards
 */
export const getWildcardData = sitecoreContext => {
  const WildcardComponent = getComponent(sitecoreContext, 'Wildcards');
  return get(WildcardComponent, 'fields.WildCards.value', {});
};

/**
 * take 3 mandatory values and Searches the wildcard value for a given component
 * @param  {object} wildcards dictionary with the information of all wildcards
 * @param  {string} componentName name of the current component where the function is called
 * @param  {string} word key to be processed
 * @return {array} array with two values, the founded wildcard value and the validation if the current value is a dictionary
 */
const getWildCardValueAndType = (wildcards, componentName, word) => {
  let wildcardValue =
    get(wildcards, `[${componentName}][${word}]`) ||
    get(wildcards, `Context[${word}]`);

  let isADictionary = false;

  // get wildcard from Dictionary if not exist in componentName or Context
  if (!wildcardValue && get(wildcards, `Dictionary[${word}]`)) {
    wildcardValue = wildcards.Dictionary[word];
    isADictionary = true;
  }
  return [wildcardValue, isADictionary];
};

/**
 * This function take 4 mandatory options to transform a text string with
 * his respective wildcards in another string with the value of wildcards
 * @param  {Object} options dictionary with the component values from sitecore
 * @param  {string} options.componentName name of the current component where the function is called
 * @param  {Object} options.contextFields dictionary with the component values from the global context of sitecore
 * @param  {Object} options.fields dictionary with the component values from sitecore
 * @param  {function} options.t function to translate the wildcard if is a dictionary
 * @param  {string} options.text string to be converted
 * @param  {Object} options.wildcards dictionary with the information of all wildcards
 * @return {string} transformed value of wildcards
 */
export const transformWildcardsToText = ({
  componentName,
  contextFields,
  fields,
  t,
  text = '',
  wildcards,
}) => {
  if (isEmpty(wildcards) || isEmpty(fields)) return text;

  const result = text.split(' ').map(word => {
    const isMatching = Array.isArray(word.match(regexToDetectTextInsideTags));
    if (isMatching) {
      const [wildcardValue, isADictionary] = getWildCardValueAndType(
        wildcards,
        componentName,
        word,
      );

      if (isADictionary && typeof t === 'function') {
        return t(wildcardValue);
      }

      return (
        wildcardValue &&
        (get(fields, `[${wildcardValue}].value`) ||
          get(contextFields, `[${wildcardValue}].value`))
      );
    }
    return word;
  });

  return result.join(' ');
};
